/* TU Beauty cart access v1.0.0: reuse native counters and transport; zero new requests. */
(function () {
  'use strict';
  if (window.TBCartUI2027) return;
  var nativeCount = null, observer = null, queued = 0;
  var current = 0, jqueryBound = false, returnToTop = false;
  function valid(value) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;
  }
  function label(count) {
    var es = /^es(?:-|$)/i.test(document.documentElement.lang || 'es');
    return es ? 'Abrir carrito, ' + count + (count === 1 ? ' unidad' : ' unidades')
      : 'Open shopping bag, ' + count + (count === 1 ? ' item' : ' items');
  }
  function paint(count) {
    if (!valid(count)) return;
    current = count;
    var text = String(count);
    document.querySelectorAll('.cart-link__count').forEach(function (node) {
      if (node.textContent.trim() !== text) node.textContent = text;
    });
    document.querySelectorAll('#TBCartTopLink,.site-nav__thumb-cart,.site-nav__link--cart,.quick-view__thumb-cart').forEach(function (node) {
      var title = label(count);
      if (node.getAttribute('aria-label') !== title) node.setAttribute('aria-label', title);
    });
    if (document.body.classList.contains('cart-has-items') !== (count > 0)) {
      document.body.classList.toggle('cart-has-items', count > 0);
    }
  }
  function fromNative() {
    queued = 0;
    if (!nativeCount || !nativeCount.isConnected) connect();
    if (!nativeCount) return;
    var text = nativeCount.textContent.trim();
    if (/^\d+$/.test(text)) paint(Number(text));
  }
  function schedule() {
    if (!queued) queued = requestAnimationFrame(fromNative);
  }
  function update(cart) {
    if (cart && valid(cart.item_count)) paint(cart.item_count);
  }
  function eventUpdate(event, data) {
    var detail = data || event.detail;
    var cart = detail && (detail.cart || detail);
    if (cart && valid(cart.item_count)) update(cart);
    else schedule(); // add.js returns line items, not an authoritative cart total.
  }
  function connect() {
    var node = document.querySelector('.site-nav__thumb-cart .cart-link__count') ||
      document.querySelector('.site-nav__link--cart .cart-link__count');
    if (node === nativeCount) return;
    if (observer) observer.disconnect();
    nativeCount = node;
    if (node && window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(node, {childList:true, characterData:true, subtree:true});
    }
  }
  function bindJQuery() {
    if (jqueryBound || !window.jQuery) return;
    jqueryBound = true;
    window.jQuery(document).on('cart:updated.tbCartUI ajaxProduct:added.tbCartUI cart:refresh.tbCartUI', eventUpdate);
    window.jQuery(document).on('ajaxComplete.tbCartUI', function (event, xhr, settings) {
      if (!settings || xhr.status < 200 || xhr.status >= 300) return;
      try {
        var url = new URL(settings.url, window.location.href);
        if (url.origin !== window.location.origin ||
          !/\/cart(?:\/(?:change|update|clear))?(?:\.js|\.json)?\/?$/.test(url.pathname)) return;
        update(xhr.responseJSON || JSON.parse(xhr.responseText));
      } catch (ignore) { /* Preserve the last confirmed count on invalid responses. */ }
    });
  }
  function start() {
    var top = document.getElementById('TBCartTopLink');
    if (!top) return;
    var seed = Number(top.getAttribute('data-initial-count'));
    if (valid(seed)) current = seed;
    connect(); fromNative(); paint(current); bindJQuery();
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('#TBCartTopLink');
      if (!link || event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var original = document.querySelector('.site-nav__thumb-cart.js-drawer-open-cart') ||
        document.querySelector('.site-nav__link--cart.js-drawer-open-cart');
      if (!original) return; // Normal /cart link remains usable, including without JS.
      event.preventDefault();
      returnToTop = true;
      original.click(); // One original entry point; never create a second cart/drawer.
    });
    ['cart:updated','ajaxProduct:added','cart:refresh'].forEach(function (name) {
      document.addEventListener(name, eventUpdate);
    });
    document.addEventListener('shopify:section:load', function () { connect(); paint(current); });
    window.addEventListener('pageshow', function () { connect(); schedule(); bindJQuery(); });
    if (window.MutationObserver) {
      var wasOpen = document.documentElement.classList.contains('js-drawer-open');
      new MutationObserver(function () {
        var open = document.documentElement.classList.contains('js-drawer-open');
        if (wasOpen && !open && returnToTop) {
          returnToTop = false;
          var anchor = document.getElementById('TBCartTopLink');
          if (anchor && anchor.getClientRects().length) anchor.focus({preventScroll:true});
        }
        wasOpen = open;
      }).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    }
  }
  window.TBCartUI2027 = {version:'1.0.0', update:update};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
}());
